
var cardLess = {};
import genaration from '../../utils/classname';
export var cardClass = genaration(cardLess, 'card');